// document ready plain js
document.addEventListener('DOMContentLoaded', function() {
    // get element with class .section-known-from .section-wrapper .section-known-from__images
    var sectionKnownFromImages = document.querySelector('.section-known-from .section-wrapper .section-known-from__images');

    // check if sectionKnownFromImages exists
    if (!sectionKnownFromImages) {
        return;
    }

    sectionKnownFromImages.addEventListener('mouseover', function(event) {
        if (!event.target.classList.contains('section-known-from__image-wrapper') && !event.target.classList.contains('section-known-from__image')) {
            sectionKnownFromImages.classList.add('no-hover');
        } else {
            sectionKnownFromImages.classList.remove('no-hover');
        }
    });
});